import { OfflineManagerState, OfflineManagerStatus } from '../containers/OfflineManager/reducer';

export const isSynchronizationInProgress = (offlineManager: OfflineManagerState): boolean => {
	// isSynchronizing covers the whole online init and clears atomically at the end. It replaces the
	// per-download flags, which could stick true after a failed download or read false mid-init.
	return offlineManager.status === OfflineManagerStatus.INITIALIZING
		|| offlineManager.isPreparingContentStructure
		|| offlineManager.isSynchronizing;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/synchronization.ts